import request from '../lib/request';

export default {
  fetchPicCaptcha() {
    return request({
      method: 'GET',
      url: '/openapi/captcha',
      baseURL: ''
    });
  },
  sendSms(params) {
    return request({
      method: 'GET',
      url: '/openapi/sms',
      params,
      baseURL: ''
    });
  },
  fetchDownloadUrls(data) {
    return request({
      method: 'POST',
      url: '/openapi/download',
      baseURL: '',
      data
    });
  }
};
